// extracted by mini-css-extract-plugin
export default {"previous-search__list--item":"PreviousSearches_previous-search__list--item__cg3nM","heading-previous":"PreviousSearches_heading-previous__P-gg6"};